document.addEventListener('DOMContentLoaded', () => {
  const root = document.documentElement;
  const allowedViews = ['3', '4', '6'];
  const allowedMobileViews = ['1', '2'];
  const storedView = window.localStorage ? window.localStorage.getItem('blackmassView') : null;
  const storedMobileView = window.localStorage ? window.localStorage.getItem('blackmassMobileView') : null;
  const defaultButton = document.querySelector('.blackmass-view-toggle.is-active');
  const defaultView = defaultButton?.dataset.blackmassView || '4';
  const initialView = allowedViews.includes(storedView)
    ? storedView
    : allowedViews.includes(defaultView)
      ? defaultView
      : '4';
  const initialMobileView = allowedMobileViews.includes(storedMobileView) ? storedMobileView : '1';

  const updateGridColumns = (view) => {
    document.querySelectorAll('.blackmass-product-grid').forEach((grid) => {
      Array.from(grid.classList).forEach((className) => {
        if (/^grid--\d+-col-desktop$/.test(className)) {
          grid.classList.remove(className);
        }
      });
      grid.classList.add(`grid--${view}-col-desktop`);
    });
  };

  const applyView = (view) => {
    const resolvedView = allowedViews.includes(view) ? view : defaultView;
    root.setAttribute('data-blackmass-view', resolvedView);
    document.querySelectorAll('.blackmass-view-toggle').forEach((button) => {
      const isActive = button.dataset.blackmassView === resolvedView;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    if (window.localStorage) {
      window.localStorage.setItem('blackmassView', resolvedView);
    }
    updateGridColumns(resolvedView);
  };

  const applyMobileView = (view) => {
    const resolvedView = allowedMobileViews.includes(view) ? view : '1';
    root.setAttribute('data-blackmass-mobile-view', resolvedView);
    document.querySelectorAll('.blackmass-mobile-view-toggle').forEach((button) => {
      const isActive = button.dataset.blackmassMobileView === resolvedView;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    if (window.localStorage) {
      window.localStorage.setItem('blackmassMobileView', resolvedView);
    }
    document.querySelectorAll('.blackmass-product-grid').forEach((grid) => {
      Array.from(grid.classList).forEach((className) => {
        if (/^grid--\d+-col-tablet-down$/.test(className)) {
          grid.classList.remove(className);
        }
      });
      grid.classList.add(`grid--${resolvedView}-col-tablet-down`);
    });
  };

  const closeSortPanels = () => {
    document.querySelectorAll('[data-blackmass-sort]').forEach((sort) => {
      const panel = sort.querySelector('.blackmass-sort__panel');
      const toggle = sort.querySelector('[data-blackmass-sort-toggle]');
      if (panel) panel.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  };

  const openSortSheet = () => {
    const overlay = document.querySelector('[data-blackmass-sort-overlay]');
    const sheet = document.querySelector('[data-blackmass-sort-sheet]');
    if (overlay) {
      requestAnimationFrame(() => overlay.classList.add('is-open'));
    }
    if (sheet) {
      requestAnimationFrame(() => sheet.classList.add('is-open'));
    }
    document.body.style.overflow = 'hidden';
  };

  const closeSortSheet = () => {
    const overlay = document.querySelector('[data-blackmass-sort-overlay]');
    const sheet = document.querySelector('[data-blackmass-sort-sheet]');
    if (overlay) overlay.classList.remove('is-open');
    if (sheet) sheet.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  const openFilterDrawer = () => {
    const summary = document.querySelector('.mobile-facets__open-wrapper');
    if (summary) summary.click();
  };

  applyView(initialView);
  applyMobileView(initialMobileView);

  document.addEventListener('click', (event) => {
    const sheetOpen = document.querySelector('.blackmass-sort-sheet.is-open');
    if (sheetOpen && !event.target.closest('[data-blackmass-sort-sheet]') && !event.target.closest('[data-blackmass-mobile-sort-open]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeSortSheet();
      return;
    }
  }, true);

  document.addEventListener('click', (event) => {
    const viewButton = event.target.closest('.blackmass-view-toggle');
    if (viewButton) {
      event.preventDefault();
      applyView(viewButton.dataset.blackmassView);
      return;
    }

    const mobileViewButton = event.target.closest('.blackmass-mobile-view-toggle');
    if (mobileViewButton) {
      event.preventDefault();
      applyMobileView(mobileViewButton.dataset.blackmassMobileView);
      return;
    }

    const sortToggle = event.target.closest('[data-blackmass-sort-toggle]');
    if (sortToggle) {
      event.preventDefault();
      const sort = sortToggle.closest('[data-blackmass-sort]');
      const panel = sort?.querySelector('.blackmass-sort__panel');
      const isOpen = panel && !panel.hidden;
      closeSortPanels();
      if (panel) {
        panel.hidden = isOpen;
        sortToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      }
      return;
    }

    const sortOption = event.target.closest('[data-blackmass-sort-option]');
    if (sortOption) {
      event.preventDefault();
      const sort = sortOption.closest('[data-blackmass-sort]');
      const select = sort?.querySelector('select[name="sort_by"]');
      if (select) {
        select.value = sortOption.dataset.sortValue;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sort.querySelectorAll('[data-blackmass-sort-option]').forEach((button) => {
        const isActive = button === sortOption;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      closeSortPanels();
      return;
    }

    const mobileSortOpen = event.target.closest('[data-blackmass-mobile-sort-open]');
    if (mobileSortOpen) {
      event.preventDefault();
      openSortSheet();
      return;
    }

    const mobileSortClose = event.target.closest('[data-blackmass-mobile-sort-close]');
    if (mobileSortClose) {
      event.preventDefault();
      closeSortSheet();
      return;
    }

    const mobileSortOption = event.target.closest('[data-blackmass-mobile-sort-option]');
    if (mobileSortOption) {
      event.preventDefault();
      const select = document.querySelector('select[name="sort_by"]');
      if (select) {
        select.value = mobileSortOption.dataset.sortValue;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      document.querySelectorAll('[data-blackmass-mobile-sort-option]').forEach((button) => {
        const isActive = button === mobileSortOption;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      document.querySelectorAll('[data-blackmass-sort-option]').forEach((button) => {
        const isActive = button.dataset.sortValue === mobileSortOption.dataset.sortValue;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      closeSortSheet();
      return;
    }

    const filterButton = event.target.closest('[data-blackmass-open-filters]');
    if (filterButton) {
      event.preventDefault();
      closeSortPanels();
      openFilterDrawer();
      return;
    }

    if (!event.target.closest('[data-blackmass-sort]')) {
      closeSortPanels();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeSortPanels();
      closeSortSheet();
    }
  });
});
